import { render, staticRenderFns } from "./Detalhe_Usuario.vue?vue&type=template&id=4e66991d&scoped=true&"
import script from "./Detalhe_Usuario.vue?vue&type=script&lang=js&"
export * from "./Detalhe_Usuario.vue?vue&type=script&lang=js&"
import style0 from "./Detalhe_Usuario.vue?vue&type=style&index=0&id=4e66991d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e66991d",
  null
  
)

export default component.exports